﻿window.lstModeReglementForWizardAchatClient = [{
    id_mode_reglement: 1,
    icon: "fas fa-credit-card",
    libelle: "Carte bancaire",
    libellePlus: "Règler de suite par CB",
    txtTooltipForCmdInternet:"Règlement par CB.<br/>Votre commande sera immédiatement activé après votre règlement."
}, {
    id_mode_reglement: 2,
    icon: "fas fa-money-bill-transfer",
    libelle: "Virement",
    libellePlus: "Editer un DEVIS pour un paiement par virement",
    txtTooltipForCmdInternet: "Règlement par virement.<br/>Votre commande sera activé à réception de votre règlement.<br/>(Si vous ne faites aucun règlement, votre commande sera ignorée)"
}, {
    id_mode_reglement: 3,
    icon: "fas fa-money-check",
    libelle: "Chèque",
    libellePlus: "Editer un DEVIS pour un paiement par chèque",
    txtTooltipForCmdInternet: "Règlement par chèque.<br/>Votre commande sera activé à réception de votre règlement.<br/>(Si vous ne faites aucun règlement, votre commande sera ignorée)"
}, {
    id_mode_reglement: 4,
    icon: "fas fa-circle-dollar-to-slot",
    libelle: "Espèce",
    txtTooltipForCmdInternet: ""
}]